window.addEventListener("DOMContentLoaded", () => {
  class pqCustomerReviews extends HTMLElement {
    constructor() {
      super();
      // 初始化元素引用
    }

    connectedCallback() {
      this.initSwiper();
    }

    initSwiper() {
      let swiperDom = this.querySelector(".swiper");
      let nextDom = this.querySelector(".pq-customer-reviews_next");
      let prevDom = this.querySelector(".pq-customer-reviews_prev");
      var swiper = new Swiper(swiperDom, {
        navigation: {
          nextEl: nextDom,
          prevEl: prevDom,
        },
        breakpoints: {
          1025: {
            slidesPerView: 4,
            spaceBetween: 24,
          },
          481: {
            slidesPerView: "auto",
            spaceBetween: 24,
          },
          0: {
            slidesPerView: "auto",
            spaceBetween: 16,
          },
        },
      });
    }
  }
  // 注册自定义元素
  customElements.define("pq-customer-reviews", pqCustomerReviews);
});
